<script setup>
// Astra DS · Voz — la voz residente de un programa: su avatar y su nombre.
//
// Figma `Pattern/Voz 2543:13639`, `Tono=principal 2543:13627` / `Tono=suave
// 2543:13633`. Entrega `2026-10-20-radio-voz-con-avatar.md`, aprobada por Pablo
// el 20.10.26.
//
//   avatar redondo a 24 · 8 · nombre en `mono/label`
//
// **El nombre va siempre con el avatar**, nunca el avatar solo. Va en las
// tarjetas de Shows (suave), en el programa en emisión, en la ficha del
// programa y en En directo (principal).
import Avatar from "./Avatar.vue";

defineProps({
  nombre: { type: String, required: true },
  imagen: { type: String, default: "" },
  // `principal` · `suave`: `text/primary` o `text/secondary`.
  tono: {
    type: String,
    default: "principal",
    validator: (v) => ["principal", "suave"].includes(v),
  },
});
</script>

<template>
  <span class="voz" :class="`voz--${tono}`">
    <Avatar :src="imagen" :alt="nombre" :size="24" />
    <span class="voz__nombre">{{ nombre }}</span>
  </span>
</template>

<style scoped lang="scss">
@use "@/assets/scss/type" as t;

.voz {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.voz__nombre {
  @include t.mono-label;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.voz--principal .voz__nombre {
  color: var(--color-text-primary);
}

.voz--suave .voz__nombre {
  color: var(--color-text-secondary);
}
</style>
